module.exports = __webpack_public_path__ + "static/carrier-payment-6a8f2a2617a670c8ae3623a54c764f3e.png";